var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return (_vm.errorsArr.length > 0)?_c('div',[_c('div',{staticClass:"validation-summary-errors"},_vm._l((_vm.errorsArr),function(err){return _c('p',{key:err},[_vm._v(_vm._s(err))])}),0)]):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }